import { PayloadAction } from "@reduxjs/toolkit";

import { ApplicationState } from "../../types";

export const setLocale = (
  state: ApplicationState,
  action: PayloadAction<ApplicationState['i18n']['locale']>
) => {
  state.i18n.locale = action.payload;
};